export const blockIconsHardwareMouseNew = (
	<span className='material-symbols-outlined'>mouse</span>
);
